// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__bU5xI","resendInfoText":"OnGoingPaymentBox_resendInfoText__2WvRI"};